import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Message from '../../../../common/Message';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import AppInput from '../../../../common/AppInput';
import ProductPreview from '../../../../common/ProductPreview';
import {
  COMPLETE_FORM,
  INFO_GO_MY_ACCOUNT_ASSEMBLE_PRODUCT,
} from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';
import { useAssembleProductStyles } from './styles';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId } = props;
  const classes = useAssembleProductStyles({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <ProductPreview mobile={mobile} />

      <Message
        severity="info"
        message={INFO_GO_MY_ACCOUNT_ASSEMBLE_PRODUCT}
        fullRounded
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {!field.hidden && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
